/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as MigrateRouteImport } from './routes/migrate'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ErrorRouteImport } from './routes/error'

const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const MigrateRoute = MigrateRouteImport.update({
  id: '/migrate',
  path: '/migrate',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/error': typeof ErrorRoute
  '/login': typeof LoginRoute
  '/migrate': typeof MigrateRoute
  '/register': typeof RegisterRoute
}
export interface FileRoutesByTo {
  '/error': typeof ErrorRoute
  '/login': typeof LoginRoute
  '/migrate': typeof MigrateRoute
  '/register': typeof RegisterRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/error': typeof ErrorRoute
  '/login': typeof LoginRoute
  '/migrate': typeof MigrateRoute
  '/register': typeof RegisterRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/error' | '/login' | '/migrate' | '/register'
  fileRoutesByTo: FileRoutesByTo
  to: '/error' | '/login' | '/migrate' | '/register'
  id: '__root__' | '/error' | '/login' | '/migrate' | '/register'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ErrorRoute: typeof ErrorRoute
  LoginRoute: typeof LoginRoute
  MigrateRoute: typeof MigrateRoute
  RegisterRoute: typeof RegisterRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/migrate': {
      id: '/migrate'
      path: '/migrate'
      fullPath: '/migrate'
      preLoaderRoute: typeof MigrateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  ErrorRoute: ErrorRoute,
  LoginRoute: LoginRoute,
  MigrateRoute: MigrateRoute,
  RegisterRoute: RegisterRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
